import {useState} from 'react';
import {useCompletarContenedores} from '../api/seguimiento';
import {tr} from '../i18n/idioma';
import {numero} from '../utilidades/formato';

// Exportaciones → Contenedores (administradores, decision 0053): reparte los Big
// Bags sin contenedor en los contenedores de Seguimiento Concentrados. Primero
// se revisa; nada se guarda hasta confirmar.
export function CompletarContenedores() {
  const [abierto, setAbierto] = useState(false);
  const completar = useCompletarContenedores();
  const r = completar.data;
  if (!abierto)
    return (
      <button
        type="button"
        onClick={() => {
          setAbierto(true);
          completar.mutate('revisar');
        }}
        className="rounded-md border border-linea bg-white px-3 py-1.5 text-sm hover:bg-papel"
      >
        {tr('⇢ Completar el contenedor de los Big Bags', '⇢ Fill in the Big Bags container')}
      </button>
    );
  return (
    <div className="space-y-3 rounded-lg border border-linea bg-white p-4 text-sm" data-prueba="completar-contenedores">
      <div className="flex items-start justify-between gap-3">
        <div>
          <h2 className="font-medium">
            {tr('Completar el contenedor de los Big Bags', 'Fill in the Big Bags container')}
          </h2>
          <p className="text-xs text-apagado">
            {tr(
              'Los Big Bags sin contenedor se reparten en los contenedores de Seguimiento Concentrados, por proveedor y en orden de BB #. Hasta 2023 (por zarpe) se reparten así; desde 2024 solo si el oro de cada contenedor cuadra, si hay un solo contenedor o si el proveedor define el contenedor. Un contenedor que el Big Bag ya tiene no se cambia.',
              'Big Bags without a container are spread into the Seguimiento Concentrados containers, by supplier and in BB # order. Up to 2023 (by departure) they are spread this way; from 2024 only if the gold of each container matches, if there is a single container or if the supplier defines the container. A container the Big Bag already has is not changed.',
            )}
          </p>
        </div>
        <button
          type="button"
          onClick={() => {
            setAbierto(false);
            completar.reset();
          }}
          aria-label={tr('Cerrar', 'Close')}
          className="text-apagado hover:text-tinta"
        >
          ×
        </button>
      </div>
      {completar.isPending && <p className="text-apagado">{tr('Revisando…', 'Reviewing…')}</p>}
      {completar.isError && <p className="text-alerta">{completar.error.message}</p>}
      {r && (
        <div className="space-y-2" role="status">
          <p className={r.aplicado ? 'rounded-md bg-verde-claro/60 p-2 font-medium text-verde-oscuro' : 'font-medium'}>
            {r.aplicado
              ? tr(
                  `Listo: ${numero(r.bolsasAsignadas)} Big Bags quedaron en su contenedor.`,
                  `Done: ${numero(r.bolsasAsignadas)} Big Bags were placed in their container.`,
                )
              : tr(
                  `Revisión (todavía no se guardó nada): ${numero(r.bolsasAsignadas)} Big Bags reciben contenedor.`,
                  `Review (nothing saved yet): ${numero(r.bolsasAsignadas)} Big Bags get a container.`,
                )}
          </p>
          {r.porRegla.length > 0 && (
            <ul className="list-disc pl-5">
              {r.porRegla.map(x => (
                <li key={x.regla}>
                  {x.etiqueta}:{' '}
                  {tr(
                    `${numero(x.exportaciones)} exportaciones, ${numero(x.bigBags)} Big Bags`,
                    `${numero(x.exportaciones)} exports, ${numero(x.bigBags)} Big Bags`,
                  )}
                  <span className="text-xs text-apagado">
                    {' '}
                    (
                    {r.asignadas
                      .filter(a => a.regla === x.regla)
                      .map(a => a.codigo)
                      .join(', ')}
                    )
                  </span>
                </li>
              ))}
            </ul>
          )}
          {r.sinAsignar.length > 0 && (
            <details>
              <summary className="cursor-pointer text-apagado">
                {tr(
                  `${numero(r.sinAsignar.length)} exportaciones con Big Bags sin contenedor se dejan como están`,
                  `${numero(r.sinAsignar.length)} exports with Big Bags without a container are left as they are`,
                )}
              </summary>
              <ul className="mt-1 list-disc pl-5 text-xs">
                {r.sinAsignar.map(s => (
                  <li key={s.codigo}>
                    {s.codigo}: {s.texto} ({tr(`${numero(s.bigBags)} Big Bags`, `${numero(s.bigBags)} Big Bags`)})
                  </li>
                ))}
              </ul>
            </details>
          )}
          {!r.aplicado && r.bolsasAsignadas > 0 && (
            <button
              type="button"
              disabled={completar.isPending}
              onClick={() => completar.mutate('aplicar')}
              className="rounded-md bg-verde-oscuro px-3 py-1.5 text-white disabled:opacity-50"
            >
              {tr('Guardar', 'Save')}
            </button>
          )}
        </div>
      )}
    </div>
  );
}
